export default __webpack_public_path__ + "./images/ai.31bcde51.png";